import { AppProvider } from '@shopify/polaris';
import Orders from './orders';
import Refunds from './refunds';
import ShowLocation from './locations/Show';
import Customers from './customers';

import translations from '@shopify/polaris/locales/en.json';

import {BrowserRouter as Router, Switch, Route, Redirect} from 'react-router-dom';
import SendQuote from "./send-quote/index";
import {ShowUser, Users} from "./users";
import { NavMenu } from '@shopify/app-bridge-react';
import SetThreshold from './settings/Threshold';
import CustomerRefunds from './refunds/Customer';
import RefundDetails from './refunds/Details';

const Main = () => {
    return (
        <AppProvider i18n={translations}>
            <NavMenu>
                <a href="/" rel="home">Home</a>
                <a href="/customers">Customers</a>
                <a href="/threshold">Threshold settings</a>
                <a href="/refunds">Refunds</a>
            </NavMenu>
            <Router>
                <Switch>
                    <Route exact path="/">
                        <Redirect to="/customers" />
                    </Route>
                    <Route exact path="/home">
                        <Redirect to="/customers" />
                    </Route>
                    <Route path="/orders/:customerid"><Orders /></Route>
                    <Route path="/createRefund/:customerid"><Refunds /></Route>
                    <Route path="/refunds/:refundId"><RefundDetails /></Route>
                    <Route path="/refunds"><CustomerRefunds /></Route>
                    <Route path="/customers"><Customers /></Route>
                    <Route path="/locations/:locationId"><ShowLocation /></Route>
                    <Route path="/send-quote"><SendQuote /></Route>

                    <Route path="/users/:userId"><ShowUser /></Route>
                    <Route path="/users"><Users /></Route>
                    <Route path="/threshold"><SetThreshold /></Route>
                </Switch>
            </Router>
        </AppProvider>
    );
}


export default Main;
